module.exports = __webpack_public_path__ + "img/img_sensor_torque.000f144d.jpg";